<template>
  <a
    title="defaqto compare tool"
    href="https://www.paymentshield.co.uk/advisers/tools-and-support/defaqto-compare-for-clients"
    target="_blank"
    aria-label="Defaqto Compare Tool"
  >
    <div class="defaqto-badge" v-if="showLocal && show">
      <v-btn
        x-small
        color="grey darken-4"
        fab
        depressed
        class="white--text ml-n3 mt-n3"
        aria-label="Close Defaqto badge"
        @click.prevent="showLocal = !showLocal"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div>Compare</div>
      <v-img
        width="55"
        :src="require('@/assets/images/defaqto/home-2024.png')"
        transition="scale-transition"
        max-width="100"
        alt="Defaqto 5-star Expert Rated"
        class="img"
      />
    </div>
  </a>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showLocal: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.defaqto-badge {
  width: 51px;
  height: 179px;
  background-color: white;
  position: fixed;
  right: 0;
  bottom: 20%;
  border-radius: 5px 0px 0px 5px;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  z-index: 3;
}

.defaqto-badge div {
  transform: rotate(-90deg);
  margin-top: 42px;
  font-weight: bold;
}

.defaqto-badge .img {
  margin-top: 35px;
}

.v-btn {
  height: 30px;
  width: 30px;
}
</style>
